module.exports = __webpack_public_path__ + "img/sprite.f257624c.svg";